import React from 'react';
import './step-slider.styles.scss';

export interface StepSliderComponentProps {
  title: string;
  steps: number;
  values?: number[];
  selectedValue: number;
  min?: number;
  max?: number;
  setSelectedValue: (volume: number) => void;
}

export const StepSliderComponent = (props: StepSliderComponentProps) => {
  // Definir valores por defecto y verificar si estamos usando un array de valores
  const usingValueArray = Boolean(props.values && props.values.length > 0);
  const min = props.min || 1;
  const max = props.max || (usingValueArray ? props.values?.length || 1 : props.steps);

  // Calcular el valor actual del slider
  const getSliderValue = () => {
    if (usingValueArray && props.values) {
      return props.values.indexOf(props.selectedValue) + 1;
    }
    return props.selectedValue;
  };

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value);
    if (usingValueArray && props.values) {
      props.setSelectedValue(props.values[value - 1]);
    } else {
      props.setSelectedValue(value);
    }
  };

  // Determinar si los botones deben estar deshabilitados
  const isMinusDisabled = usingValueArray && props.values
    ? props.values.indexOf(props.selectedValue) <= 0
    : props.selectedValue <= min;

  const isPlusDisabled = usingValueArray && props.values
    ? props.values.indexOf(props.selectedValue) >= (props.values.length - 1)
    : props.selectedValue >= max;

  return <>
    <div className='StepSliderComponent container'>
      <div className='container'>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
        }}>
          <i
            className="las la-minus"
            onClick={() => {
              if (isMinusDisabled) return;

              if (usingValueArray && props.values) {
                const index = props.values.indexOf(props.selectedValue) - 1;
                if (index >= 0) {
                  props.setSelectedValue(props.values[index]);
                }
              } else {
                const newValue = props.selectedValue - 1;
                if (newValue >= min) {
                  props.setSelectedValue(newValue);
                }
              }
            }}
            aria-disabled={isMinusDisabled}
            style={{
              opacity: isMinusDisabled ? 0.5 : 1,
              cursor: isMinusDisabled ? 'default' : 'pointer'
            }}
          ></i>
          <input
            type='range'
            min={min}
            max={usingValueArray && props.values ? props.values.length : max}
            value={getSliderValue()}
            step='1'
            className={`n n${props.steps}`}
            onChange={handleSliderChange}
          />
          <i
            className="las la-plus"
            onClick={() => {
              if (isPlusDisabled) return;

              if (usingValueArray && props.values) {
                const index = props.values.indexOf(props.selectedValue) + 1;
                if (index < props.values.length) {
                  props.setSelectedValue(props.values[index]);
                }
              } else {
                const newValue = props.selectedValue + 1;
                if (newValue <= max) {
                  props.setSelectedValue(newValue);
                }
              }
            }}
            aria-disabled={isPlusDisabled}
            style={{
              opacity: isPlusDisabled ? 0.5 : 1,
              cursor: isPlusDisabled ? 'default' : 'pointer'
            }}
          ></i>
        </div>
      </div>
    </div>
  </>
}
